import { SEC_ApiCall, SEC_DataApiPost } from '../func';

/**
 * Load permission groups and staff membership for the Groups page.
 * A school with no configured groups may receive null or no groups property
 * from older API deployments, which is equivalent to an empty group list.
 */
export async function getSysManagerGroups() {
  const response = await SEC_ApiCall('sysmanager/groups');
  if (!response || typeof response !== 'object' || !Array.isArray(response.staff)) {
    throw new Error(response?.message || 'Unexpected groups response');
  }

  if (response.groups != null && !Array.isArray(response.groups)) {
    throw new Error(response?.message || 'Unexpected groups response');
  }
  if (response.availableTools != null && !Array.isArray(response.availableTools)) {
    throw new Error(response?.message || 'Unexpected groups response');
  }
  if (response.bookingGroups != null && !Array.isArray(response.bookingGroups)) {
    throw new Error(response?.message || 'Unexpected groups response');
  }
  if (response.bookingRooms != null && !Array.isArray(response.bookingRooms)) {
    throw new Error(response?.message || 'Unexpected groups response');
  }
  if (response.rotas != null && !Array.isArray(response.rotas)) {
    throw new Error(response?.message || 'Unexpected groups response');
  }

  return {
    ...response,
    groups: response.groups ?? [],
    availableTools: response.availableTools ?? [],
    bookingGroups: response.bookingGroups ?? [],
    bookingRooms: response.bookingRooms ?? [],
    rotas: response.rotas ?? [],
  };
}

/** Perform one supported group-management action. */
export async function updateSysManagerGroups(payload) {
  const response = await SEC_DataApiPost(
    'sysmanager/groups/manage',
    JSON.stringify(payload),
    {},
  );
  if (!response || typeof response !== 'object' || response.status !== 'success') {
    throw new Error(response?.message || 'Unexpected group update response');
  }
  return response;
}
